/** @prettier */
import i18n from 'i18next';
import Backend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';

import { es } from 'date-fns/locale';

const dateFnsLocales = { 'es-MX': es };

const availableLanguages = ['en-GB', 'es-MX'];

let next = i18n;

const initLocales = (lng = 'en-GB', configLanguages) => {
  i18n
    .use(Backend)
    .use(initReactI18next)
    .init({
      lng,
      fallbackLng: 'en-GB',
      keySeparator: '.',
      load: 'currentOnly',
      whitelist: configLanguages || availableLanguages,
      interpolation: {
        escapeValue: false,
      },
      react: {
        wait: true,
        useSuspense: false,
      },
      backend: {
        loadPath: '/assets/locales/{{lng}}/{{lng}}.json',
      },
    });

  next = i18n;
  /**
   * The below is temporary and needed for development/testing ease.
   *
   * Running window.x_i18n.changeLanguage('es-MX') will apply on-fly translation.
   */
  window.x_i18n = i18n;
};

export default {
  dateFnsLocales,
  initLocales,
  i18n: next,
};
